/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface JobFiltersDTO
 */
export interface JobFiltersDTO  {
    /**
     * 
     * @type {Array<string>}
     * @memberof JobFiltersDTO
     */
    processTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobFiltersDTO
     */
    tenants?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobFiltersDTO
     */
    jobTypes?: Array<string>;
}

/**
 * Check if a given object implements the JobFiltersDTO interface.
 */
export function instanceOfJobFiltersDTO(value: object): value is JobFiltersDTO {
    return true;
}

export function JobFiltersDTOFromJSON(json: any): JobFiltersDTO {
    return JobFiltersDTOFromJSONTyped(json, false);
}

export function JobFiltersDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobFiltersDTO {
    if (json == null) {
        return json;
    }
    return {
        
              'processTypes': json['processTypes'] == null ? undefined : json['processTypes'],
              'tenants': json['tenants'] == null ? undefined : json['tenants'],
              'jobTypes': json['jobTypes'] == null ? undefined : json['jobTypes'],
    };
}

export function JobFiltersDTOToJSON(json: any): JobFiltersDTO {
    return JobFiltersDTOToJSONTyped(json, false);
}

export function JobFiltersDTOToJSONTyped(value?: JobFiltersDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'processTypes': value['processTypes'] == null? value['processTypes']: value['processTypes'],
        'tenants': value['tenants'] == null? value['tenants']: value['tenants'],
        'jobTypes': value['jobTypes'] == null? value['jobTypes']: value['jobTypes'],
    };
}


